export default "__VITE_ASSET__CDzTBEYj__"